import React from 'react'

function AdvisorList({ advisors, type }) {
    if (!advisors || advisors.length === 0) return null
    const filteredAdvisors = advisors.filter((advisor) => advisor.type === type)
    if (filteredAdvisors.length === 0) return null
    return (
        <>
            {filteredAdvisors.map((advisor, index) => (
                <span key={index}>
                    {advisor.name}
                    {index < filteredAdvisors.length - 1 && ', '}
                </span>
            ))}
        </>
    )
}

export default AdvisorList
